import { Container, Typography, Link as MaterialLink } from '@material-ui/core';
import { format } from 'date-fns';
import parse, { Element, domToReact } from 'html-react-parser';
// eslint-disable-next-line import/no-extraneous-dependencies
import _ from 'lodash';
import Link from 'next/link';

import { BlogProps } from '@pages/blog/[id]';
import useStyles from '@views/blog/article/styles';

const ArticleView: React.FC<Required<BlogProps>> = ({ article }) => {
  const classes = useStyles();

  const { title, preview, body, author, createdAt, image } = article;
  const { firstName, lastName, avatar } = author;
  const content = parse(body, {
    // eslint-disable-next-line react/no-unstable-nested-components
    replace: (domNode) => {
      if (
        domNode instanceof Element &&
        domNode.name === 'a' &&
        domNode.attribs.href.startsWith('/')
      ) {
        return (
          <Link href={domNode.attribs.href} passHref>
            <MaterialLink className="blue">
              {domToReact(domNode.children)}
            </MaterialLink>
          </Link>
        );
      }

      return domNode;
    },
  });

  return (
    <>
      <section className={classes.topSection}>
        <Container maxWidth={false}>
          <Link href="/blog" passHref>
            <MaterialLink id="go-back-button-blog-article" className="blue">
              <i className="icon-arrow-left" />
              Back
            </MaterialLink>
          </Link>
          <div className={classes.articleImage}>
            <img src={image} alt={title} />
          </div>
          <Typography className={classes.articleTitle} variant="h1">
            {title}
          </Typography>
          <Typography className={classes.articlePreview} variant="body2">
            {preview}
          </Typography>
          <div className={classes.authorBlock}>
            <img src={avatar} alt={`${firstName} ${lastName} avatar`} />
            <Typography variant="body1">
              {`${firstName} ${lastName}`}
            </Typography>
            <Typography className={classes.articleDate} variant="body2">
              {format(new Date(createdAt), 'dd MMMM yyyy')}
            </Typography>
          </div>
        </Container>
      </section>
      <section className={classes.contentSection}>
        <Container maxWidth={false}>
          <div className={classes.articleContent}>{content}</div>
        </Container>
      </section>
    </>
  );
};

export default ArticleView;
